"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _systemConstants = require("@telus-uds/system-constants");
var _useViewport = require("./useViewport");
var _useViewportListener = _interopRequireDefault(require("./useViewportListener"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * Provides an up-to-date viewport value from system-constants, available via the `useViewport` hook
 */const ViewportProvider = _ref => {
  let {
    children
  } = _ref;
  // Default to the smallest viewport for mobile-first SSR. On client side, this is updated
  // by useViewportListener in a layout effect before anything is shown to the user.
  const [viewport, setViewport] = _react.default.useState(_systemConstants.viewports.keys[0]);
  (0, _useViewportListener.default)(setViewport);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_useViewport.ViewportContext.Provider, {
    value: viewport,
    children: children
  });
};
ViewportProvider.propTypes = {
  children: _propTypes.default.node.isRequired
};
var _default = exports.default = ViewportProvider;